



























import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import Modal from '@/components/Modal.vue'
import DateInput2 from '@/components/inputs/DateInput2.vue'
import TextArea from '@/components/inputs/TextArea.vue'
import { UserModule } from '@/store/modules/user.module'
import { EAlertStatus } from '@zunta/configurations'

@Component({
  props: {
    alert: {
      type: Object,
      required: true
    }
  },
  components: {
    Modal,
    DateInput2,
    TextArea
  }
})
export default class AlertPostponeModal extends Vue {
  userModuleInstance: UserModule = getModule(UserModule, this.$store);

  dueDate: Date | null = null;
  comments: string = '';
  enableValidation: boolean = false;

  validate () {
    if (!this.dueDate) {
      return false
    }
    if (!this.comments) {
      return false
    }
    return true
  }
  async submit () {
    this.enableValidation = true
    if (this.validate()) {
      await this.userModuleInstance.changeAlertStatus({
        alertId: this.$props.alert.id,
        data: {
          comments: this.comments,
          dueDate: this.dueDate as Date,
          status: EAlertStatus.POSTPONED
        }
      })
      this.$emit('close')
    }
  }
}
